import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTwitter, faInstagram } from '@fortawesome/free-brands-svg-icons';
import { faShoppingBag } from '@fortawesome/free-solid-svg-icons';
import React, { useState, useEffect } from "react";
import { MDBIcon, MDBCollapse } from 'mdb-react-ui-kit';
import {Link} from 'react-scroll'

import tripleTLogo from "../../assets/images/TTTLogo.png";
import pressKit from "../../assets/downloadable/presskit.pdf";
import "../../assets/styles/Header.css";

export default function Header() {
    const [showMenu, setShowMenu] = useState(false);

    const toggleMenu = () => setShowMenu(!showMenu);

    return (
    <>
        <div className="header-wrapper">
            <div className='header-wrapper-sub'>
                <div className="header-tttLogo-wrapper">
                    <img className="header-tttLogo" src={tripleTLogo} />
                </div>
                <div className="header-right-section">
                    <div className="header-link-wrapper">
                        <ul>
                            <li>
                                <Link  to="music" spy={true} smooth={true}>
                                    MUSIC
                                </Link>
                            </li>
                            <li>
                                <Link  to="shows" spy={true} smooth={true}>
                                    SHOWS
                                </Link>
                            </li>
                            <li>
                                <Link  to="gallery" spy={true} smooth={true}>
                                    VIDEOS
                                </Link>
                            </li>
                            <li>
                                <a href={pressKit} download={true}>
                                    ABOUT
                                </a>
                            </li>
                        </ul>
                    </div>
                    <div className="header-socials">
                        <div>
                            <a target='_blank' href='https://mobile.twitter.com/tirothetyrant'>
                                <FontAwesomeIcon icon={faTwitter} />
                            </a>
                        </div>
                        <div>
                            <a target='_blank' href='https://www.instagram.com/tirothetyrant/?hl=en'>
                                <FontAwesomeIcon icon={faInstagram} />
                            </a>
                        </div>
                        <div>
                            <a target='_blank' href='https://tirothetyrant.myshopify.com/'>
                                <FontAwesomeIcon icon={faShoppingBag} />
                            </a>
                        </div>
                    </div>
                </div>
                <div className='header-right-section-small-screen'>
                    <div className='header-menu-expand'>
                        <MDBIcon onClick={toggleMenu} className='header-expander' fas icon="bars" size="2x" />
                    </div>
                </div>
            </div>
            <div className='header-collapsible'>
                <MDBCollapse show={showMenu}>
                    <div className="header-link-wrapper">
                        <ul>
                            <li>
                                <Link  to="music" spy={true} smooth={true}>
                                    MUSIC
                                </Link>
                            </li>
                            <li>
                                <Link  to="shows" spy={true} smooth={true}>
                                    SHOWS
                                </Link>
                            </li>
                            <li>
                                <Link  to="gallery" spy={true} smooth={true}>
                                    VIDEOS
                                </Link>
                            </li>
                            <li>
                                <a href={pressKit} download={true}>
                                    ABOUT
                                </a>
                            </li>
                        </ul>
                    </div>
                    <div className="header-socials">
                        <div>
                            <a target='_blank' href='https://mobile.twitter.com/tirothetyrant'>
                                <FontAwesomeIcon icon={faTwitter} />
                            </a>
                        </div>
                        <div>
                            <a target='_blank' href='https://www.instagram.com/tirothetyrant/?hl=en'>
                                <FontAwesomeIcon icon={faInstagram} />
                            </a>
                        </div>
                        <div>
                            <a target='_blank' href='https://tirothetyrant.myshopify.com/'>
                                <FontAwesomeIcon icon={faShoppingBag} />
                            </a>
                        </div>
                    </div>
                </MDBCollapse>
            </div>
        </div>
        
    </>
    )
}